import Service from "../../Services";

const Utility = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    getPathImage({ commit }, data) {
      return Service.UtilityAPI.getPathImage(data);
    },
    // eslint-disable-next-line no-unused-vars
    getPathFile({ commit }, data) {
      return Service.UtilityAPI.getPathFile(data);
    }
  }
};
export default Utility;
